import { deleteUser, getUsers } from 'admin/actions/user';
import Button from 'admin/components/shared/Button';
import { allAllowed, organizationManagerAllowed, shopRoles } from 'admin/routes';
import { formatDate } from 'admin/utils';
import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Trash from '~/images/trash.svg';
import Link from '../../atoms/Link';
import Table from '../../atoms/Table';
import Breadcrumb from '../../shared/Breadcrumb';
import styles from './styles.scss';

const NameEmailWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Icon = styled.img`
  height: 1.5em;
  cursor: pointer;
`;

const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
  },
};

const HEADERS = [
  { label: '名前', size: 4.5 },
  { label: '管理権限', size: 3 },
  { label: '管理店舗', size: 3 },
  { label: '最終利用日', size: 1 },
  { label: '削除', size: 0.5 },
];

class SettingsUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      selectedUser: {
        id: '',
        email: '',
        role: '',
        shops: [],
      },
      isModalOpen: false,
    };
  }

  componentWillMount() {
    getUsers().then((json) => {
      this.setState({ users: json });
    });
  }

  invite() {
    this.props.history.push('/settings/admin-users/invite');
  }

  isEditable(role) {
    const pos1 = allAllowed.indexOf(this.props.user.role);
    const pos2 = allAllowed.indexOf(role);
    return pos1 <= pos2 && !shopRoles.includes(this.props.user.role);
  }

  hasShop(role) {
    return shopRoles.indexOf(role) >= 0;
  }

  isLoginUser() {
    return this.props.user.id === this.state.selectedUser.id;
  }

  onConfirm() {
    this.closeModal();
    const isLoginUser = this.isLoginUser();
    deleteUser(this.state.selectedUser.id).then(() => {
      if (isLoginUser) {
        location.href = '/logout';
      } else {
        getUsers().then((json) => this.setState({ users: json }));
      }
    });
  }

  openModal(user) {
    this.setState({
      isModalOpen: true,
      selectedUser: user,
    });
  }

  closeModal() {
    this.setState({
      isModalOpen: false,
      selectedUser: { id: '' },
    });
  }

  loginUserMessage() {
    return this.isLoginUser() ? (
      <div styleName="modal-alert">
        <p>ログイン中のユーザを削除しようとしています。実行すると管理画面からログアウトします。</p>
      </div>
    ) : null;
  }

  modalBody() {
    return (
      <div styleName="modal-body">
        <p>以下の管理ユーザを削除してよろしいですか？</p>
        {this.loginUserMessage()}
        <table>
          <tbody>
            <tr>
              <td>名前</td>
              <td>{this.state.selectedUser.name}</td>
            </tr>
            <tr>
              <td>メールアドレス</td>
              <td>{this.state.selectedUser.email}</td>
            </tr>
            <tr>
              <td>管理権限</td>
              <td>{this.state.selectedUser.role}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: '各種設定', href: '', active: true },
      { value: '管理ユーザ設定', href: '', active: true },
    ];

    const inviteLink = organizationManagerAllowed.includes(this.props.user.role) ? (
      <Button styleName="btn" onClick={this.invite.bind(this)}>
        管理ユーザを新規作成・登録状況
      </Button>
    ) : null;

    return (
      <div>
        <Breadcrumb items={crumb} />
        {inviteLink}
        <Table styles={{ marginTop: '20px' }}>
          <Table.Header>
            <Table.Row>
              {HEADERS.map((h) => (
                <Table.Cell size={h.size} key={h.label}>
                  {h.label}
                </Table.Cell>
              ))}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {this.state.users?.map((row) => (
              <Table.Row>
                <Table.Cell wordBreak="keep-all">
                  <NameEmailWrapper>
                    <div>{row.name}</div>
                    {this.isEditable(row.role) ? (
                      <Link to={`/settings/admin-users/${row.id}/edit`}>{row.email}</Link>
                    ) : (
                      row.email
                    )}
                  </NameEmailWrapper>
                </Table.Cell>
                <Table.Cell wordBreak="keep-all">{row.role}</Table.Cell>
                <Table.Cell wordBreak="break-word">
                  {this.hasShop(row.role) && row.shops.map((shop) => shop.name).join(', ')}
                </Table.Cell>
                <Table.Cell>{formatDate(row.last_used_at, 'YYYY/MM/DD')}</Table.Cell>
                <Table.Cell>
                  {this.isEditable(row.role) && (
                    <Icon src={Trash} alt="Delete" onClick={() => this.openModal(row)} />
                  )}
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
        <Modal
          isOpen={this.state.isModalOpen}
          onRequestClose={this.closeModal.bind(this)}
          shouldCloseOnOverlayClick={true}
          closeTimeoutMS={200}
          ariaHideApp={false}
          style={modalStyles}
        >
          {this.modalBody()}
          <div styleName="button-group">
            <Button onClick={this.closeModal.bind(this)} color="gray">
              キャンセル
            </Button>
            <Button onClick={this.onConfirm.bind(this)} color="danger">
              実行
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(CSSModules(SettingsUser, styles));
